import { BaseSerializer } from "./baseSerializer.ts";
import {Trace} from "@models/trace.model.ts";
import {UserSerializer} from "@models/serializers/userSerializer.ts";


export class TraceSerializer extends BaseSerializer {

    public deserialize( data: any ): Trace {

        const trace = new Trace();
        this._copyAttributes(trace, data);

        if (data.user) {
            const userSerializer = new UserSerializer();
            trace.user = userSerializer.deserialize(data.user);
        }

        return trace;
    }

}
